var _excluded = ["svgRef"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#DDDDDD",
  stroke: "#404041",
  strokeMiterlimit: 10,
  d: "M26,361.8c0-6.7,0-13.4,0-20.2c0.1-0.9,0.3-1.8,0.4-2.7 c0.8-16.4,3.3-32.6,7.5-48.6c9.5-36.3,26.9-69.2,51.9-98.8c10-11.9,21-23,33.5-32.9c1.2-0.9,2.2-1.7,4-1.7 c88.6,0.1,177.1,0.1,265.7,0.1c1.1,0,2.4,0.4,3.2,1c3.4,2.7,6.8,5.4,10,8.3c23.4,21.2,41.9,45.4,56.1,72.4 c17,32.3,26.1,66.3,27.6,102c0.9,20.4-0.6,40.8-4.6,60.9c-1.3,6.5-2.2,13.3-4.7,19.5c-7.3,18.6-21,32.2-41,40.4 c-12.2,5-25.2,6.6-38.5,6.6c-93.7,0-187.5,0-281.2-0.1c-5.5,0-11-0.2-16.4-0.9c-20.9-2.5-38.3-10.8-51.6-26 c-6-6.9-11-14.4-13.3-22.9c-4.1-15.7-6.6-31.6-7.7-47.7C26.5,367.8,26.3,364.8,26,361.8z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#DDDDDD",
  stroke: "#404041",
  strokeMiterlimit: 10,
  d: "M342.7,43.7 c3.9,0.3,7.8,0.6,11.6,1.1c16.2,1.8,31,6.9,44.9,14.6c14.3,7.9,26.8,17.8,37.3,29.6c0.5,0.6,0.9,1.1,1.5,1.8 c-6.3,5.3-12.4,10.5-18.5,15.7c-14.8,12.5-29.5,25-44.3,37.5c-1.5,1.3-2.9,1.8-4.9,1.8c-76.4-0.1-152.9-0.1-229.3,0 c-1.7,0-2.8-0.5-4-1.5C116.5,126.8,96,109.4,75.5,92c-0.4-0.4-0.8-0.8-1.5-1.3c1.2-1.3,2.3-2.7,3.5-4c17.1-18,37.6-31.6,62.9-38.6 c8.8-2.4,17.8-3.7,26.9-4c0.5,0,1-0.1,1.5-0.2c1.8,0,3.7,0,5.6,0c3.4,0.3,6.8,0.6,10.2,0.9c12.9,1.5,24.6,5.8,35.9,11.3 c7.4,3.6,14.8,7.2,22.4,10.5c4.9,2.1,10.2,3.2,15.8,2.5c5.2-0.7,10.1-2.2,14.8-4.5c6.2-2.9,12.3-6,18.5-9 c10.9-5.4,22.3-9.4,34.7-10.8c3.4-0.4,6.8-0.6,10.2-0.9C339,43.7,340.8,43.7,342.7,43.7z"
}));

var SvgBag = function SvgBag(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bag.1d2402ea.svg";
export { ForwardRef as ReactComponent };